import Layout from '../views/layout/index.vue'
import i18n from '@/lang'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'
import PtLayout from '@pt/views/layout/index.vue'

export default {
  path: '/creative-assets',
  component: Layout,
  redirect: 'noredirect',
  name: 'creative-assets',
  icon: 'asset_library',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.myassets.name'),
  },
  children: [
    {
      path: 'media',
      name: 'creative-assets.media',
      redirect: '/creative-assets/media/resources',
      component: () =>
        import('../views/pt-entry/creative-assets/media/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myassets.asset'),
        defaultPath: '/creative-assets/media',
      },
      children: [
        {
          path: 'resources',
          name: 'creative-assets.media.resources',
          component: () =>
            import('../views/pt-entry/creative-assets/media/resource.vue'),
          meta: {
            title: i18n.t('playTurbo.assetLibrary.asset.tab.label'),
            defaultPath: '/creative-assets/media',
            keys: ['assets'],
          },
        },
        {
          path: 'works',
          name: 'creative-assets.media.works',
          component: () =>
            import('../views/pt-entry/creative-assets/media/work.vue'),
          meta: {
            title: '作品集',
            defaultPath: '/creative-assets/media',
          },
        },
      ],
    },
    {
      path: 'template',
      name: 'creative-assets.template',
      redirect: '/creative-assets/template/playable',
      component: () =>
        import('../views/pt-entry/creative-assets/template/index.vue'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myassets.template'),
        defaultPath: '/creative-assets/template',
      },
      children: [
        {
          path: 'playable',
          name: 'creative-assets.template.playable',
          component: () =>
            import('../views/pt-entry/creative-assets/template/playable.vue'),
          meta: {
            title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
            defaultPath: '/creative-assets/template',
            keys: ['ps'],
          },
        },
        {
          path: 'video',
          name: 'creative-assets.template.video',
          component: () =>
            import('../views/pt-entry/creative-assets/template/video.vue'),
          meta: {
            title: i18n.t('playTurbo.templateLibrary.template.publicVideo'),
            defaultPath: '/creative-assets/template',
          },
        },
      ],
    },
    {
      path: 'media/resources/detail',
      name: 'creative-assets.media.resources.detail',
      hidden: true,
      component: () =>
        import(
          '../views/pt-entry/creative-assets/media/resource-detail/detail.vue'
        ),
      meta: {
        title: '创意资产详情',
        defaultPath: '/creative-assets/media',
      },
    },
    {
      path: 'voice-lab',
      name: 'creative-assets.voice-lab',
      component: () =>
        import('../views/pt-entry/creative-assets/voice-lab/index.vue'),
      meta: {
        title: i18n.t('playTurbo.voiceLab.templateHeader.title'),
        defaultPath: '/creative-assets/voice-lab',
      },
    },
    generateConfigRoute(
      {
        title: i18n
          .t('playTurbo.leftMenu.aside.menu.settings.promote')
          .toString(),
        pageId: 'app_manage',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          keys: ['gm', 'assets', 've', 'vrec', 'ps'],
        },
      },
    ),
  ],
}
